import React from "react";
import { Plus, Minus, Sparkles, Wine, ChevronDown } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { BOTTLE_MENU } from "@/lib/bottles";

// Standalone bottle photos (cut-outs with neon glow + black bg)
const BOTTLE_IMG_MAP = {
  "absolut": "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/v2xnjob5_2251D45F-704E-4AD3-8985-41807EF1B1F5.png",
  "grey-goose": "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/x7b5d1n0_B58A2135-4280-40BA-A51B-073205FAFD33.png",
  "belvedere": "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/6m3o2whn_012B99D8-A70B-4BEE-9339-CDF5B9254A7A.png",
  "ciroc": "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/4vcsib10_E9A412DF-E984-42C8-ACD1-CB392A882FD7.png",
  "au": "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/s3xpni89_92302C1A-7226-4B07-B297-65FFC5DB0C3F.png",
  "tanqueray": "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/jnbj3sqg_6B512541-47BF-4338-ABC3-53A2F9F63F2D.png",
  "bombay": "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/27nm0rqv_673F083E-FD7F-403F-BACA-C7580805A76E.png",
  "smirnoff": "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/8i9612ml_7862B86D-CB8D-4059-81CA-DB39A5E11C30.png",
  "beefeater": "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/vspk7tbx_B3F9F724-EF0F-45E9-8D69-068AE087A4D1.png",
  "gordons-pink": "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/gdnv5pdi_9B336076-C20D-4CEC-A0C0-6664255E7A75.png",
  "gordons": "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/vl7vbvoc_7A7A415E-E65C-44B9-AD25-810152B71020.png",
  "chivas-regal": "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/fg0yg8un_DF9E163E-7362-4167-ABCA-567754A69960.png",
  "courvoisier": "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/6eor4o7e_AB10B906-DE71-4A5A-8D95-2F0119255B2B.png",
  "hennessy": "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/5kq83j6a_EBAF77B5-064B-4572-BAC6-BAFAA861FD2C.png",
  "southern-comfort": "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/nq0oo88w_1EC180DC-51E3-4492-A195-3A6D0828259F.png",
  "jameson": "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/98oq7941_9F00C613-F250-485E-AFBE-DB3B05482ACB.png",
  "jack-daniels": "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/u9tbfsfm_9CD4CA79-78BE-4B85-B788-E60F946CE1DF.png",
  "captain-morgan-dark": "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/w32x4die_4B73DFF8-4208-4F1F-AAAC-A7C03C42538C.png",
  "captain-morgan-spiced": "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/9p93207l_EE418C04-9981-4CE9-8523-B37686798FAC.png",
  "black-label": "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/hba6be9i_23634E20-BAC4-4498-A294-E1DF5858C633.png",
  "red-label": "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/5459jp42_590C4499-7CEE-4AED-BD96-F1F8ED294ACC.png",
  "havana-club-7": "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/iy9w7x0r_AFAA0843-521A-40B4-AED6-078EDCF39227.png",
  "bacardi": "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/qbkuppzj_3181F9F5-5E9D-4B78-9AEE-DF46144AE727.png",
  "arehucas": "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/el00qz0r_BB700D76-43D3-4E7C-9A4A-54401ED87BE5.png",
  "moet": "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/2tketb9s_19B7C769-BB00-49C4-BD42-6F39FFD1DCF2.png",
  "moet-ice": "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/lylzrv78_CB52AA75-9A4D-48BE-B966-4648138D0670.png",
};
function bottleImageFor(name) {
  const n = (name || "").toLowerCase();
  if (n.includes("belvedere")) return BOTTLE_IMG_MAP.belvedere;
  if (n.includes("grey goose")) return BOTTLE_IMG_MAP["grey-goose"];
  if (n.includes("absolut")) return BOTTLE_IMG_MAP.absolut;
  if (n.includes("cîroc") || n.includes("ciroc")) return BOTTLE_IMG_MAP.ciroc;
  if (/\bau\b/.test(n)) return BOTTLE_IMG_MAP.au;
  if (n.includes("tanqueray")) return BOTTLE_IMG_MAP.tanqueray;
  if (n.includes("bombay")) return BOTTLE_IMG_MAP.bombay;
  if (n.includes("smirnoff")) return BOTTLE_IMG_MAP.smirnoff;
  if (n.includes("beefeater")) return BOTTLE_IMG_MAP.beefeater;
  if (n.includes("gordon") && n.includes("pink")) return BOTTLE_IMG_MAP["gordons-pink"];
  if (n.includes("gordon")) return BOTTLE_IMG_MAP.gordons;
  if (n.includes("chivas")) return BOTTLE_IMG_MAP["chivas-regal"];
  if (n.includes("courvoisier")) return BOTTLE_IMG_MAP.courvoisier;
  if (n.includes("hennessy")) return BOTTLE_IMG_MAP.hennessy;
  if (n.includes("southern")) return BOTTLE_IMG_MAP["southern-comfort"];
  if (n.includes("jameson")) return BOTTLE_IMG_MAP.jameson;
  if (n.includes("jack")) return BOTTLE_IMG_MAP["jack-daniels"];
  if (n.includes("captain") && n.includes("dark")) return BOTTLE_IMG_MAP["captain-morgan-dark"];
  if (n.includes("captain")) return BOTTLE_IMG_MAP["captain-morgan-spiced"];
  if (n.includes("black label")) return BOTTLE_IMG_MAP["black-label"];
  if (n.includes("red label")) return BOTTLE_IMG_MAP["red-label"];
  if (n.includes("havana")) return BOTTLE_IMG_MAP["havana-club-7"];
  if (n.includes("bacardi") || n.includes("bacardí")) return BOTTLE_IMG_MAP.bacardi;
  if (n.includes("arehucas")) return BOTTLE_IMG_MAP.arehucas;
  if (n.includes("moët ice") || n.includes("moet ice")) return BOTTLE_IMG_MAP["moet-ice"];
  if (n.includes("moët") || n.includes("moet")) return BOTTLE_IMG_MAP.moet;
  return null;
}

// 5×4 sprite sheet for the remaining 20 branded bottles
const BOTTLE_SHEET_URL =
  "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/culxej1q_19AD1CC6-BBF3-4BA2-8622-548749B6A18D.png";
// [col, row] in the 5×4 sheet (0-indexed)
const BOTTLE_SPRITE = {
  "ciroc-flavours":        [0, 0],
  "au-flavours":           [1, 0],
  "absolut-flavours":      [2, 0],
  "smirnoff-1l":           [3, 0],
  "bombay":                [4, 0],
  "hennessy":              [0, 1],
  "courvoisier":           [1, 1],
  "chivas-regal":          [2, 1],
  "jack-daniels":          [3, 1],
  "jameson":               [4, 1],
  "southern-comfort":      [0, 2],
  "red-label":             [1, 2],
  "black-label":           [2, 2],
  "captain-morgan-spiced": [3, 2],
  "captain-morgan-dark":   [4, 2],
  "bacardi":               [0, 3],
  "havana-club-7":         [1, 3],
  "arehucas":              [2, 3],
  "moet":                  [3, 3],
  "moet-ice":              [4, 3],
};
function spriteStyleFor(id) {
  const pos = BOTTLE_SPRITE[id];
  if (!pos) return null;
  const [col, row] = pos;
  return {
    backgroundImage: `url(${BOTTLE_SHEET_URL})`,
    // 5x wide / 5x tall — cell height effectively = 1/5 of sheet so the label strip
    // at the bottom of each row is cropped out, leaving just the bottle.
    backgroundSize: "500% 500%",
    backgroundPosition: `${col * 25}% ${row * 31.25}%`,
    backgroundRepeat: "no-repeat",
  };
}

/**
 * Reusable categorized VIP Bottle Menu.
 *
 * Props:
 *   cart: { [bottleId]: qty }
 *   onInc(id): increment
 *   onDec(id): decrement
 *   compact: render in a tighter form (used inside /book)
 *   showHeader: render the big "VIP BOTTLE MENU" heading (only on /tables)
 *   accordion: collapse each category into an expandable dropdown (mobile-friendly)
 */
export default function BottleMenu({ cart = {}, onInc, onDec, compact = false, showHeader = true, accordion = false }) {
  const { t } = useLang();
  // Track which categories are open when in accordion mode. Every category
  // is collapsed on first render — the guest taps the header to reveal that
  // section's bottles. Prevents a long single-scroll list on mobile.
  const [openCats, setOpenCats] = React.useState({});
  const toggleCat = (key) =>
    setOpenCats((o) => ({ ...o, [key]: !o[key] }));
  // Count selected bottles per category for the chip badge
  const catCount = (cat) =>
    cat.items.reduce((sum, b) => sum + (cart[b.id] || 0), 0);
  return (
    <section data-testid="bottle-menu" className={compact ? "" : "mt-16 md:mt-28"}>
      {/* Shared SVG chroma-key filter — drops the black bg from bottle photos */}
      <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true">
        <defs>
          <filter id="bottle-menu-chroma" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="1 0 0 0 0
                      0 1 0 0 0
                      0 0 1 0 0
                      1 1 1 0 -0.55"
            />
            <feComponentTransfer>
              <feFuncA type="linear" slope="25" intercept="-8" />
            </feComponentTransfer>
          </filter>
        </defs>
      </svg>

      {showHeader && (
        <div className="text-center">
          <div className="text-[10px] uppercase tracking-[0.32em] text-neon font-bold">{t("bottles.kicker")}</div>
          <h2 className="h-display text-5xl sm:text-6xl md:text-8xl mt-2 md:mt-3">
            {t("bottles.title.1")} <span className="stroke-pink">{t("bottles.title.2")}</span>
          </h2>
          <div
            className="mt-6 md:mt-8 inline-flex items-center gap-2 px-5 py-3 rounded-full border border-gold/40 text-gold text-xs md:text-sm uppercase tracking-[0.22em] md:tracking-[0.32em] font-bold backdrop-blur"
            style={{ background: "linear-gradient(135deg, rgba(255,200,87,0.12), rgba(255,27,141,0.12))" }}
          >
            <Sparkles size={14} className="shrink-0" /> {t("bottles.perk")}
          </div>
          <p className="text-white/55 mt-4 text-xs md:text-sm">{t("bottles.note")}</p>
        </div>
      )}

      <div className={(showHeader ? "mt-10 md:mt-14 " : "") + "space-y-4 md:space-y-12"}>
        {BOTTLE_MENU.map((cat) => {
          const isOpen = accordion ? !!openCats[cat.catKey] : true;
          const selectedInCat = catCount(cat);
          return (
          <div key={cat.catKey} data-testid={`bottle-cat-${cat.catKey}`}>
            {accordion ? (
              <button
                type="button"
                onClick={() => toggleCat(cat.catKey)}
                data-testid={`bottle-cat-toggle-${cat.catKey}`}
                aria-expanded={isOpen}
                className="w-full flex items-center gap-3 px-4 py-3 md:py-4 rounded-2xl transition"
                style={{
                  background:
                    "linear-gradient(90deg, rgba(255,27,141,0.08) 0%, rgba(0,0,0,0.55) 60%, rgba(255,27,141,0.08) 100%)",
                  border: `1.5px solid ${isOpen ? "rgba(255,27,141,0.95)" : "rgba(255,27,141,0.35)"}`,
                  boxShadow: isOpen
                    ? "0 0 16px rgba(255,27,141,0.45), inset 0 0 14px rgba(255,27,141,0.12)"
                    : "inset 0 0 10px rgba(255,27,141,0.05)",
                }}
              >
                <span
                  className="w-2.5 h-2.5 rounded-full shrink-0"
                  style={{ background: cat.color, boxShadow: `0 0 10px ${cat.color}` }}
                />
                <h3 className="text-lg md:text-2xl font-heading uppercase tracking-wide text-left flex-1 truncate">
                  {t(`bottles.cat.${cat.catKey}`)}
                </h3>
                {selectedInCat > 0 && (
                  <span
                    className="text-[10px] md:text-xs font-bold px-2.5 py-1 rounded-full whitespace-nowrap"
                    style={{
                      background: "linear-gradient(135deg,#FF1B8D,#FF6BC6)",
                      color: "#000",
                    }}
                  >
                    {selectedInCat}
                  </span>
                )}
                <ChevronDown
                  size={20}
                  className="text-neon shrink-0 transition-transform"
                  style={{ transform: isOpen ? "rotate(180deg)" : "rotate(0deg)" }}
                />
              </button>
            ) : (
              <div className="flex items-center gap-3 mb-4 md:mb-5">
                <span
                  className="w-2.5 h-2.5 rounded-full shrink-0"
                  style={{ background: cat.color, boxShadow: `0 0 10px ${cat.color}` }}
                />
                <h3 className={(compact ? "text-2xl md:text-3xl" : "text-3xl md:text-4xl") + " font-heading uppercase"}>
                  {t(`bottles.cat.${cat.catKey}`)}
                </h3>
                <div className="flex-1 h-px bg-gradient-to-r from-white/20 to-transparent" />
              </div>
            )}

            {isOpen && (
            <div className={(accordion ? "mt-3 md:mt-4 " : "") + "flex flex-col gap-3 md:gap-4"}>
              {cat.items.map((bottle) => {
                const qty = cart[bottle.id] || 0;
                const isSelected = qty > 0;
                const photoSrc = bottleImageFor(bottle.name);
                const spriteStyle = !photoSrc ? spriteStyleFor(bottle.id) : null;
                return (
                  <div
                    key={bottle.id}
                    data-testid={`bottle-row-${bottle.id}`}
                    className="relative rounded-2xl md:rounded-3xl transition"
                    style={{
                      background:
                        "linear-gradient(90deg, rgba(255,27,141,0.06) 0%, rgba(0,0,0,0.55) 60%, rgba(255,27,141,0.06) 100%)",
                      border: `1.5px solid ${isSelected ? "rgba(255,27,141,1)" : "rgba(255,27,141,0.35)"}`,
                      boxShadow: isSelected
                        ? "0 0 18px rgba(255,27,141,0.5), inset 0 0 16px rgba(255,27,141,0.15)"
                        : "inset 0 0 12px rgba(255,27,141,0.05)",
                    }}
                  >
                    <div className="flex items-stretch min-h-[78px] md:min-h-[88px]">
                      {/* LEFT — name + qty controls */}
                      <div className="flex-1 px-3 md:px-5 py-3 md:py-3.5 flex flex-col justify-center min-w-0">
                        <div className="font-heading text-base md:text-2xl text-white leading-tight break-words">
                          {bottle.name}
                        </div>
                        {qty > 0 && (
                          <div className="mt-1.5 flex items-center gap-2">
                            <button
                              type="button"
                              onClick={() => onDec?.(bottle.id)}
                              aria-label="Remove one"
                              data-testid={`bottle-dec-${bottle.id}`}
                              className="w-7 h-7 rounded-full flex items-center justify-center border border-neon/50 text-neon hover:bg-neon hover:text-black transition"
                            >
                              <Minus size={12} />
                            </button>
                            <span className="font-heading text-base text-neon min-w-[18px] text-center">{qty}</span>
                            <button
                              type="button"
                              onClick={() => onInc?.(bottle.id)}
                              aria-label="Add one"
                              data-testid={`bottle-inc-${bottle.id}`}
                              className="w-7 h-7 rounded-full flex items-center justify-center border border-neon/50 text-neon hover:bg-neon hover:text-black transition"
                            >
                              <Plus size={12} />
                            </button>
                          </div>
                        )}
                      </div>

                      {/* CENTER — neon pink elegant price */}
                      <div className="flex flex-col items-center justify-center px-2 md:px-5 shrink-0">
                        {bottle.price ? (
                          <div
                            className="font-heading leading-none tracking-tight whitespace-nowrap"
                            style={{
                              fontSize: "clamp(1rem, 2.5vw, 1.8rem)",
                              fontWeight: 900,
                              color: "#FF1B8D",
                              textShadow: "0 0 4px rgba(255,27,141,0.25)",
                            }}
                          >
                            €{bottle.price}
                          </div>
                        ) : (
                          <span className="text-white/50 italic text-[10px] uppercase tracking-widest">{t("bottles.onRequest")}</span>
                        )}
                      </div>

                      {/* ADD button — its own column, never overlaps the bottle */}
                      {qty === 0 && (
                        <div className="flex items-center justify-center shrink-0 pr-1.5 md:pr-2">
                          <button
                            type="button"
                            onClick={() => onInc?.(bottle.id)}
                            aria-label="Add one"
                            data-testid={`bottle-add-${bottle.id}`}
                            disabled={!bottle.price}
                            className="w-8 h-8 md:w-10 md:h-10 rounded-full flex items-center justify-center transition"
                            style={{
                              background: bottle.price
                                ? "linear-gradient(135deg,#FF1B8D,#FF6BC6)"
                                : "rgba(0,0,0,0.4)",
                              boxShadow: bottle.price ? "0 0 12px rgba(255,27,141,0.55)" : "none",
                              opacity: bottle.price ? 1 : 0.4,
                              cursor: bottle.price ? "pointer" : "not-allowed",
                            }}
                          >
                            <Plus size={14} className="text-black" strokeWidth={3} />
                          </button>
                        </div>
                      )}

                      {/* RIGHT — bottle photo (if available) or category icon */}
                      <div className="flex shrink-0 w-12 md:w-20 relative items-center justify-center self-stretch">
                        <div
                          className="absolute inset-y-0 left-0 w-px"
                          style={{ background: "linear-gradient(180deg, transparent 0%, rgba(255,27,141,0.35) 50%, transparent 100%)" }}
                        />
                        <div
                          className="absolute inset-0 m-auto pointer-events-none"
                          style={{
                            width: "120%",
                            height: "160%",
                            background:
                              "radial-gradient(ellipse at center, rgba(255,27,141,0.35) 0%, rgba(255,27,141,0.12) 45%, transparent 75%)",
                            filter: "blur(10px)",
                          }}
                        />
                        {photoSrc ? (
                          <img loading="lazy" decoding="async"                             src={photoSrc}
                            alt={`${bottle.name}`}
                            draggable={false}
                            className="absolute left-1/2 -translate-x-1/2 w-auto select-none pointer-events-none"
                            style={{
                              top: "50%",
                              transform: "translate(-50%, -50%)",
                              height: "115%",
                              maxHeight: "92px",
                              zIndex: 5,
                              filter:
                                "url(#bottle-menu-chroma) drop-shadow(0 0 8px rgba(255,27,141,0.7)) drop-shadow(0 0 18px rgba(255,27,141,0.35))",
                            }}
                          />
                        ) : spriteStyle ? (
                          <div
                            aria-label={`${bottle.name} bottle`}
                            data-testid={`bottle-sprite-${bottle.id}`}
                            className="absolute left-1/2 -translate-x-1/2 select-none pointer-events-none"
                            style={{
                              top: "50%",
                              transform: "translate(-50%, -50%)",
                              width: "180%",
                              height: "115%",
                              maxHeight: "92px",
                              zIndex: 5,
                              filter:
                                "drop-shadow(0 0 8px rgba(255,27,141,0.7)) drop-shadow(0 0 18px rgba(255,27,141,0.35))",
                              ...spriteStyle,
                            }}
                          />
                        ) : (
                          <Wine
                            size={32}
                            strokeWidth={1.2}
                            className="relative"
                            style={{
                              color: cat.color,
                              filter: `drop-shadow(0 0 8px ${cat.color}) drop-shadow(0 0 14px ${cat.color}55)`,
                              zIndex: 5,
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            )}
          </div>
          );
        })}
      </div>

      {!compact && (
        <p className="text-white/45 text-xs md:text-sm mt-10 text-center max-w-xl mx-auto">
          {t("bottles.disclaimer")}
        </p>
      )}
    </section>
  );
}
